import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from 'gsap';
import { SmoothScrollService } from '../smooth-scroll.service';
import { ThemeService } from '../theme.service';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  isMenuOpen = false;
  isDarkTheme = false;
  private animationContext?: gsap.Context;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly router: Router,
    private readonly smoothScroll: SmoothScrollService,
    private readonly themeService: ThemeService,
    public readonly language: LanguageService,
  ) {
    this.isDarkTheme = this.themeService.theme === 'dark';
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.animationContext = gsap.context(() => {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from('.brand-mark', { autoAlpha: 0, x: -16, rotate: -14, scale: .82, duration: .7 })
        .from('.brand-copy > *', {
          autoAlpha: 0,
          x: -10,
          duration: .5,
          stagger: .1,
        }, '-=.42')
        .from('.nav-links a', {
          autoAlpha: 0,
          y: -10,
          duration: .45,
          stagger: .08,
        }, '-=.4');
    }, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.animationContext?.revert();
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onBrandClick(): void {
    this.isMenuOpen = false;

    const currentPath = this.router.url.split('?')[0].split('#')[0];
    if (currentPath === '/works' || currentPath === '/en/works') {
      this.smoothScroll.scrollToTop();
    }
  }

  toggleTheme(): void {
    this.isDarkTheme = this.themeService.toggle() === 'dark';
  }

  languageLink(): string {
    return this.language.counterpart(this.router.url);
  }

  switchLanguage(): void {
    this.isMenuOpen = false;
    this.language.chooseLanguage(this.language.isEnglish ? 'fr' : 'en');
  }
}
